import gql from 'graphql-tag';

const UPDATE_LOCATION_WITH_LICENSE = gql`
  mutation updateLocationWithLicense(
    $id: ID!
    $name: String
    $description: String
    $street: String
    $city: String
    $state: StateType
    $country: CountryType
    $email: String
    $url: String
    $phone: String
    $contact: String
    $formattedAddress: String
    $zip: String
    $locationKey: String
    $province: String
    $audienceType: AudienceType
    $licenseId: ID
    $designations: [DesignationType!]
    $licenseIdentifier: String
  ) {
    updateLocationWithLicense(
      data: {
        name: $name
        description: $description
        street: $street
        city: $city
        state: $state
        country: $country
        email: $email
        url: $url
        phone: $phone
        contact: $contact
        formattedAddress: $formattedAddress
        zip: $zip
        locationKey: $locationKey
        province: $province
        audienceType: $audienceType
        licenseId: $licenseId
        designations: $designations
        licenseIdentifier: $licenseIdentifier
      }
      where: { id: $id }
    ) {
      id
      name
      description
      street
      city
      state
      province
      lat
      lng
      formattedAddress
      email
      phone
      contact
      url
      locationKey
      zip
      audienceType
      licenses(first: 1) {
        id
        designations
        licenseIdentifier
      }
      transConfig {
        id
        cart
        menuDataKey
      }
      geoframe {
        id
        name
        start
        end
        polygons {
          id
          geometry
        }
        circles {
          id
          coordinate {
            lat
            lng
          }
          radius
        }
      }
      updatedBy {
        id
        name
      }
    }
  }
`;

export default UPDATE_LOCATION_WITH_LICENSE;
